import React from 'react';
// import PropTypes from 'prop-types';
// import { useNavigate, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import Style from '../common/css/HawkSoftStyle.module.scss';
import Layout from './Layout';
import Navbar from './Navbar';
import { useAgency } from '../contexts/AgencyContext';
import { getAgencyTheme } from '../../utils/agencyThemes';

const Homelayout = ({ children }) => {
    const { agency } = useAgency();
    const theme = getAgencyTheme(agency);
    const themeStyle = {
        ...(theme ? {
            '--agency-primary': theme.primary,
            '--agency-secondary': theme.secondary,
            '--agency-focus-ring': theme.focusRing,
            '--agency-button-text': theme.buttonTextColor,
            '--agency-button-hover-text': theme.buttonHoverTextColor,
            '--agency-navbar-bg': theme.backgroundNavColor,
        } : {}),
    };
    return (
        <div style={themeStyle}>
            <Navbar />
            <Layout>
                <div className={Style.wrapper}>
                    {children}
                </div>
            </Layout>
        </div>
    );
};
export default Homelayout;